import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Query, Mutation } from 'react-apollo'
import Loader from 'components/Loader'
import { Container, Header, Button, Table } from 'semantic-ui-react'
import InfiniteScroll from 'react-infinite-scroller'
import {
  WELCOMES_QUERY,
  UPDATE_WELCOME_MUTATION,
  DELETE_WELCOME,
} from 'graphql/queries'

class Welcomes extends Component {
  state = {
    limit: 20,
    offset: 0,
    q: '',
    hasMore: true,
  }

  render() {
    const { hasMore, limit, offset } = this.state
    const variables = {
      limit,
      offset,
    }

    return (
      <Container>
        <Header as="h1" content="Welcome Headers" />
        <Query query={WELCOMES_QUERY} variables={variables}>
          {({ data, loading, error, fetchMore }) => {
            if (loading) {
              return <div>loading...</div>
            }

            if (error) {
              return <div>Error: {error.message}</div>
            }

            return (
              <Table>
                <InfiniteScroll
                  loadMore={() =>
                    fetchMore({
                      variables: { offset: data.welcomes.length },
                      updateQuery: (prev, { fetchMoreResult, variables }) => {
                        if (!fetchMoreResult) return prev
                        if (!fetchMoreResult.welcomes.length) {
                          this.setState({ hasMore: false })
                        }
                        return {
                          ...prev,
                          welcomes: [
                            ...prev.welcomes,
                            ...fetchMoreResult.welcomes,
                          ],
                        }
                      },
                    })
                  }
                  hasMore={hasMore}
                  loader={<Loader />}
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Info</Table.HeaderCell>
                      <Table.HeaderCell>Published</Table.HeaderCell>
                      <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {data.welcomes.map(welcome => (
                      <Table.Row key={welcome.id}>
                        <Table.Cell width={8}>{welcome.info}</Table.Cell>
                        <Table.Cell width={4}>
                          {String(welcome.active)}
                        </Table.Cell>
                        <Table.Cell width={4}>
                          <div style={{ display: 'flex' }}>
                            <Link to={`/welcomes/edit/${welcome.id}`}>
                              <Button basic color="blue" content="Edit" />
                            </Link>
                            <Mutation
                              mutation={UPDATE_WELCOME_MUTATION}
                              refetchQueries={[
                                { query: WELCOMES_QUERY, variables },
                              ]}
                            >
                              {(updateWelcome, { data, loading, error }) => {
                                return (
                                  <Button
                                    basic
                                    loading={loading}
                                    color="orange"
                                    style={{
                                      width: '100%',
                                    }}
                                    content={
                                      welcome.active ? 'Unpublish' : 'Publish'
                                    }
                                    onClick={async () =>
                                      await updateWelcome({
                                        variables: {
                                          id: welcome.id,
                                          input: {
                                            active: !welcome.active,
                                          },
                                        },
                                      })
                                    }
                                  />
                                )
                              }}
                            </Mutation>
                            <Mutation
                              mutation={DELETE_WELCOME}
                              refetchQueries={[
                                { query: WELCOMES_QUERY, variables },
                              ]}
                            >
                              {deleteWelcome => {
                                return (
                                  <Button
                                    basic
                                    color="red"
                                    content="Delete"
                                    onClick={async () => {
                                      await deleteWelcome({
                                        variables: {
                                          id: welcome.id,
                                        },
                                      })
                                    }}
                                  />
                                )
                              }}
                            </Mutation>
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </InfiniteScroll>
              </Table>
            )
          }}
        </Query>
      </Container>
    )
  }
}

export default Welcomes
